import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SettingRow from './SettingRow';
import Table from '../common/Table'

export default class SettingTable extends Table {
    render() {
        return (
                
                    <table className="table table-stripped table-hover mb-0">
                        <thead className="thead-light">
                                <tr>
                                {this.props.header.map((item, i) => <th onClick={item.isSort ? this.handleSortData : ()=>{}} column={item.name} key={i}>{item.title} <span className={item.isSort ? ( item.name == this.state.columnSort ? (this.state.typeSort == 1 ? 'glyphicon glyphicon-sort-by-alphabet pull-right' : 'glyphicon glyphicon-sort-by-alphabet-alt pull-right') : 'glyphicon glyphicon-sort pull-right') : 'glyphicon'}></span></th>)
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.data.map((dataRow, i) => {
                                let parent = <SettingRow onEdit={this.handleEdit} onDelete={this.handleDelete} key={i} data={dataRow} header={this.props.header}/>
                                let children = null
                                if(dataRow.children && dataRow.children.length > 0){
                                        children = dataRow.children.map((child, i) => {
                                                return <SettingRow onEdit={this.handleEdit} onDelete={this.handleDelete} key={i} data={child} header={this.props.header} childrenClass='dafault'/>
                                        });   
                                } 
                                return [parent, children]
                            })}
                        </tbody>
                    </table>
                
                    );
    }
}